export default __webpack_public_path__ + "static/media/h4g-logo-rect.21dcc82d.png";